import Plan from '@/classes/Plan'
import { useEncryptionStore } from '@/stores/encryption'
import { usePlanStore, type StoredPlanData } from '@/stores/plan'
import type { PlanData } from '@/types'
import localforageLib from 'localforage'

type UnknownPlan = StoredPlanData | PlanData

function isLegacyPlanData(plan: UnknownPlan): plan is PlanData {
	return !('version' in plan)
}

const localforage = localforageLib.createInstance({
	name: 'sessions',
	storeName: 'plans',
})

export async function planV1EncryptMigration() {
	const planStore = usePlanStore()

	const planKeys = await localforage.keys()

	for (const id of planKeys) {
		const planData = await localforage.getItem<UnknownPlan>(id)
		if (planData === null || !isLegacyPlanData(planData)) continue

		// Encrypt and save the plan
		await planStore.savePlan(new Plan(planData))
	}
}
